<form #empForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/employee']">Employee</a> > {{ employee.name || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(empForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="isFormDisabled && employee.id" type="button" mat-stroked-button (click)="printBadge()">
        <mat-icon>badge</mat-icon> Print Badge
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Employee Name</mat-label>
            <input #empname="ngModel" type="text" matInput name="name" [(ngModel)]="employee.name" required>
            <mat-error *ngIf="empname.invalid && empname.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Category</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedCategory" (valueChange)="changeValue($event)" required>
              <mat-option *ngFor="let category of categories" [value]="category.value">{{ category.viewValue }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Department</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedDepartment" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keyup)="onDepartmentKey($event)" matInput name="category_list">
              <mat-option *ngFor="let department of filteredDepartments" [value]="department.id">{{ department.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>User Name</mat-label>
            <input #user="ngModel" type="text" matInput name="user_name" [(ngModel)]="employee.user_name" required>
            <mat-error *ngIf="user.invalid && user.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Password</mat-label>
            <input #pass="ngModel" type="text" matInput name="password" [(ngModel)]="employee.password" required>
            <mat-error *ngIf="pass.invalid && pass.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Linked User (optional)</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedUser">
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keyup)="onUserKey($event)" matInput name="user_list">
              <mat-option [value]="null">-- None --</mat-option>
              <mat-option *ngFor="let u of filteredUsers" [value]="u.id">{{ u.username }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="employee" [recordId]="employee.id"></app-audit-log-viewer>
</form>
